import React, { createContext, useContext, useEffect, useState } from "react";
import { authMe, authLogin, authRegister, authLogout } from "../lib/api";

const AuthCtx = createContext(null);
export const useAuth = () => useContext(AuthCtx);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = anon, object = authed

  useEffect(() => {
    authMe().then(setUser).catch(() => setUser(false));
  }, []);

  const login = async (email, password) => { const u = await authLogin({ email, password }); setUser(u); return u; };
  const register = async (name, email, password) => { const u = await authRegister({ name, email, password }); setUser(u); return u; };
  const logout = async () => { try { await authLogout(); } catch {} setUser(false); };

  return <AuthCtx.Provider value={{ user, setUser, login, register, logout }}>{children}</AuthCtx.Provider>;
}
